module.exports = __webpack_public_path__ + "img/q-8-2@2x.3a185b31.png";